import './Footer.css'

const Footer = () => (
  <footer className='footer'>
  </footer>
)

export default Footer